/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {NgModule} from '@angular/core';
import {AoaBoardSubspecialtyService} from './aoa-board-subspecialty.service';

@NgModule({
    providers: [
        AoaBoardSubspecialtyService
    ]
})
export class AoaBoardSubspecialtyModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/board/aoa/subspecialty/aoa-board-subspecialty.module.ts